import React from 'react';
import { RootStateOrAny, useSelector, shallowEqual } from 'react-redux';
import { Stack, Text, Link, Image, ImageFit } from '@fluentui/react';
import { isBrightColor } from '@sendent/nextcloud-api';
import {
    Utilities,
    replaceAllInString,
    resolveThemeColors,
} from '../../helpers';
import { useAppSelector } from '../../store';
import { selectTranslate } from '../../store/selectors/ui';

const FONT_SIZE = 12;
const LINE_HEIGHT = 16;
const WORDMARK_HEIGHT = 14;

const Footer = () => {
    const appState = useSelector((state: RootStateOrAny) => state.appReducer);
    const translate = useAppSelector(selectTranslate);
    const colors = useAppSelector(resolveThemeColors, shallowEqual);

    const styles = {
        root: {
            paddingLeft: 10,
            paddingRight: 10,
            width: '100%',
        },
    };

    const textStyles = {
        root: { fontSize: FONT_SIZE, lineHeight: LINE_HEIGHT },
    };

    const isBright = isBrightColor(colors.appBg);

    const copyrightStyles = {
        root: {
            fontSize: FONT_SIZE,
            lineHeight: LINE_HEIGHT,
            textDecoration: 'none',
            color: colors.appBgText,
            selectors: {
                ':hover': { color: colors.appBgText },
                ':active': { color: colors.appBgText },
            },
        },
    };

    const wordmark = isBright
        ? 'assets/sendent_wordmark.png'
        : 'assets/sendent_wordmark_light.png';

    const copyrightText = replaceAllInString(
        translate('footer_copyright_text'),
        {
            '{YEAR}': new Date().getFullYear().toString(),
        },
    );

    return (
        <div className="footer">
            <Stack
                horizontal
                horizontalAlign="space-between"
                verticalAlign="center"
                styles={styles}
            >
                <Text>
                    {Utilities.formatString(
                        translate('footer_version_text_fmt'),
                        appState.appConfig.version,
                    )}
                </Text>
                <Stack
                    horizontal
                    verticalAlign="center"
                    tokens={{ childrenGap: 5 }}
                >
                    <Text styles={textStyles}>Powered by</Text>
                    <Image
                        src={wordmark}
                        alt="sendent"
                        height={WORDMARK_HEIGHT}
                        imageFit={ImageFit.contain}
                    />
                    <Link
                        href={appState.appConfig.organizationPage}
                        target="_blank"
                        styles={copyrightStyles}
                    >
                        {copyrightText}
                    </Link>
                </Stack>
            </Stack>
        </div>
    );
};

export default Footer;
